
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitobhimashankarcab() {



    const cardData =
    {
        keyword: 'Mumbai to Bhimashankar Cab',
        heading: 'S9 Travels:  Mumbai to Bhimashankar Cab',
        headingDescription: 'S9 Travels offers Mumbai to Bhimashankar Cab Service, ensuring a comfortable, reliable, and hassle-free journey. Whether you are planning a pilgrimage to the Bhimashankar Jyotirlinga Temple or exploring the scenic beauty of the Western Ghats, our Innova cabs provide a smooth and safe ride. With spacious interiors, luxury features, and professional drivers, we guarantee a stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Bhimashankar cab with S9 Travels today!',


        top: 'Top Places to Visit in Shirdi with S9 Travels',

"topPlaces": [
    {
      "title": "Bhimashankar Temple",
      "description": "One of the 12 Jyotirlingas of Lord Shiva, Bhimashankar Temple is the most revered site in the region. Nestled in the Sahyadri Hills, the temple is known for its stunning Nagara-style architecture and deep spiritual significance."
    },
    {
      "title": "Bhimashankar Wildlife Sanctuary",
      "description": "A paradise for nature lovers and wildlife enthusiasts, this sanctuary is home to rare species like the Indian Giant Squirrel (Shekru). The lush greenery and diverse flora and fauna make it a great place for trekking and birdwatching."
    },
    {
      "title": "Gupt Bhimashankar",
      "description": "A lesser-known yet sacred spot, Gupt Bhimashankar is believed to be the original place where the Jyotirlinga was formed. Hidden in a dense forest, it is a serene and spiritual retreat for devotees."
    },
    {
      "title": "Hanuman Lake",
      "description": "A peaceful spot surrounded by greenery, Hanuman Lake is ideal for relaxation and picnics. It is also a good place to spot birds and enjoy the natural beauty of Bhimashankar."
    },
    {
      "title": "Nagphani Point",
      "description": "Also known as the Duke’s Nose, Nagphani Point offers breathtaking panoramic views of the surrounding hills and valleys. A popular trekking destination, it is known for its thrilling trails and scenic beauty."
    },
    {
      "title": "Sahyadri Hills Trek",
      "description": "Bhimashankar is a major trekking destination in the Sahyadri range. Trekkers can explore various routes that pass through dense forests, waterfalls, and picturesque landscapes, making it an adventurous experience."
    },
    {
      "title": "Ahupe Ghat",
      "description": "A hidden gem near Bhimashankar, Ahupe Ghat is a picturesque mountain pass offering mesmerizing views of the valleys. The trek to Ahupe village is rewarding, with lush greenery and misty hills along the way."
    },
    {
      "title": "Bhimashankar Viewpoint",
      "description": "A perfect spot to admire the natural beauty of Bhimashankar, this viewpoint offers stunning sunrise and sunset views. It’s a great place for photography and enjoying the tranquility of the hills."
    },
    {
      "title": "Bhorgiri Fort",
      "description": "An ancient fort near Bhimashankar, Bhorgiri Fort offers an exciting trek along with fascinating historical ruins. The fort is surrounded by caves, making it an interesting place for history buffs and adventure seekers."
    },
    {
      "title": "Shivneri Fort",
      "description": "Located a little away from Bhimashankar, Shivneri Fort is the birthplace of Chhatrapati Shivaji Maharaj. It is a great place to explore Maratha history while enjoying spectacular views of the region."
    }
],

"services": [
    {
      "name": "Mumbai to Bhimashankar Cab Service",
      "description": "S9 Travels offers reliable and comfortable cab services for travelers going from Mumbai to Bhimashankar. Whether you're going for a pilgrimage or sightseeing, our professional drivers ensure a smooth and safe journey."
    },
    {
      "name": "Book Mumbai to Bhimashankar Taxi",
      "description": "Booking a taxi from Mumbai to Bhimashankar is easy with S9 Travels. Whether you prefer a one-way trip or a round trip, we provide convenient booking options for your journey to the Bhimashankar temple."
    },
    {
      "name": "Affordable Mumbai to Bhimashankar Cab",
      "description": "Looking for an affordable cab service from Mumbai to Bhimashankar? S9 Travels offers budget-friendly options that provide great value for your money while ensuring comfort and safety on your trip."
    },
    {
      "name": "Private Cab Service from Mumbai to Bhimashankar",
      "description": "For a personalized and private travel experience, choose S9 Travels' private cab service from Mumbai to Bhimashankar. Enjoy a direct, comfortable, and hassle-free ride with our professional drivers."
    },
    {
      "name": "Bhimashankar Pilgrimage Taxi from Mumbai",
      "description": "S9 Travels offers dedicated pilgrimage taxi services from Mumbai to Bhimashankar. Whether you're visiting the temple for spiritual reasons or a peaceful retreat, our services ensure a safe and comfortable journey."
    },
    {
      "name": "Mumbai to Bhimashankar One-Way or Round Trip",
      "description": "Whether you're planning a one-way journey or a round trip from Mumbai to Bhimashankar, S9 Travels provides flexible options to suit your travel needs. Enjoy a stress-free and comfortable ride with our experienced drivers."
    },
    {
      "name": "Bhimashankar Temple Tour Taxi from Mumbai",
      "description": "Experience a spiritual tour of the Bhimashankar temple with S9 Travels' taxi service. Our knowledgeable drivers will guide you to the temple and ensure a comfortable and peaceful trip."
    },
    {
      "name": "Bhimashankar Sightseeing Cab",
      "description": "Explore the beautiful sights around Bhimashankar with S9 Travels' sightseeing cab service. Whether you're visiting the temple or exploring the nearby attractions, our cabs offer the perfect way to see all the sights comfortably."
    },
    {
      "name": "Luxury Cab for Bhimashankar Trip",
      "description": "For those who prefer to travel in luxury, S9 Travels offers premium cab services for your trip to Bhimashankar. Enjoy a luxurious ride with top-class amenities and a professional driver."
    },
    {
      "name": "Group Travel to Bhimashankar",
      "description": "Planning a group trip to Bhimashankar? S9 Travels provides group travel cabs that ensure everyone travels comfortably and together. Whether it's a family or corporate group, our spacious vehicles cater to your needs."
    },
    {
      "name": "Mumbai to Bhimashankar Private Cab",
      "description": "For a private and comfortable journey to Bhimashankar from Mumbai, choose S9 Travels' private cab service. Our professional drivers will ensure that you enjoy a peaceful and relaxing trip to your destination."
    }
],

"tableData": [
  ["Mumbai to Bhimashankar Cab Service", "Book Mumbai to Bhimashankar Taxi"],
  ["Affordable Mumbai to Bhimashankar Cab", "Private Cab Service from Mumbai to Bhimashankar"],
  ["Bhimashankar Pilgrimage Taxi from Mumbai", "Mumbai to Bhimashankar One-Way or Round Trip"],
  ["Bhimashankar Temple Tour Taxi from Mumbai", "Bhimashankar Sightseeing Cab"],
  ["Luxury Cab for Bhimashankar Trip", "Group Travel to Bhimashankar"],
  ["Mumbai to Bhimashankar Private Cab", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Journey",
    "WhyChoosedescription": "S9 Travels provides a comfortable and scenic Mumbai to Bhimashankar cab service. Our well-maintained vehicles, including the Toyota Innova, offer a smooth ride, allowing you to enjoy the beautiful landscapes during the drive while traveling in comfort and style."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "Whether you're heading to Bhimashankar for a spiritual visit or a relaxing getaway, our cab service ensures timely pick-ups and reliable service throughout the trip. Our experienced drivers will make sure you reach your destination on time and in the best possible condition."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our drivers are well-versed with the route from Mumbai to Bhimashankar, ensuring a safe and efficient journey. They prioritize your comfort and safety, navigating the road with expertise to provide a smooth and trouble-free ride."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Mumbai to Bhimashankar cab service with no hidden charges. We ensure clear and transparent pricing from the start, so you can plan your trip within your budget without worrying about unexpected costs."
  },
  {
    "WhyChooseheading": "Safety First on Every Journey",
    "WhyChoosedescription": "Your safety is our priority. Our cabs are equipped with modern safety features such as GPS tracking, seat belts, and airbags. Whether you're traveling with family or friends, you can rest assured that your journey from Mumbai to Bhimashankar will be secure and comfortable."
  },
  {
    "WhyChooseheading": "Flexible Pick-up and Drop-off Locations",
    "WhyChoosedescription": "We offer flexible pick-up and drop-off locations in Mumbai and Bhimashankar, ensuring that your travel plans are tailored to your convenience. You can start your journey from home, office, or any preferred spot, and we'll take care of the rest."
  },
  {
    "WhyChooseheading": "24/7 Availability for Your Travel Convenience",
    "WhyChoosedescription": "S9 Travels is available 24/7 for your Mumbai to Bhimashankar trip, so you can book your cab at any time, whether it's for an early morning departure or a late-night return. Our customer service team is always ready to assist with any requests or modifications."
  },
  {
    "WhyChooseheading": "Customizable Travel Experience",
    "WhyChoosedescription": "Each trip is unique, and we offer customizable travel options for your Mumbai to Bhimashankar journey. Whether you need to make stops along the way, adjust your timing, or request special services, we’ll tailor your trip to suit your preferences."
  }
]










    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Bhimashankar with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Bhimashankar is easy! You can book your ride via our website or app, or contact our customer service team for personalized assistance to plan your trip comfortably.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Bhimashankar travel?',
            answer: 'We offer a range of vehicles for your Mumbai to Bhimashankar journey, including sedans, SUVs, and premium cars like the Toyota Innova, ensuring you have a comfortable and smooth ride throughout the trip.',
          },
          {
            question: 'How long does the journey from Mumbai to Bhimashankar take?',
            answer: 'The journey from Mumbai to Bhimashankar typically takes around 3.5 to 5 hours, depending on the traffic conditions. Our experienced drivers ensure a safe and efficient trip, with timely arrivals at your destination.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Bhimashankar?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the route to Bhimashankar. They ensure a safe, comfortable, and smooth journey for all passengers.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Bhimashankar?',
            answer: 'Yes, we offer round-trip bookings for Mumbai to Bhimashankar. You can plan your return trip according to your schedule, and we will ensure a smooth journey back to Mumbai after your visit.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Bhimashankar cab service?',
            answer: 'Our pricing for Mumbai to Bhimashankar cab services varies depending on the type of vehicle, duration, and any special requests you may have. Contact us for a customized quote based on your travel needs.',
          },
          {
            question: 'Do you provide pickup from Mumbai airport or hotels for Bhimashankar trips?',
            answer: 'Yes, we provide convenient pickup services from Mumbai airport or your hotel for your trip to Bhimashankar. We ensure a seamless start to your journey with a hassle-free pickup from your preferred location.',
          },
          {
            question: 'Can I request additional stops on the way to Bhimashankar?',
            answer: 'Yes, if you would like to make any additional stops for sightseeing or breaks on the way to Bhimashankar, please inform us when making your booking. We will tailor the trip to accommodate your requests.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Bhimashankar trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated upfront when booking your trip. We aim for full transparency in pricing so you can plan accordingly.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Bhimashankar cab service?',
            answer: 'S9 Travels offers reliable, comfortable, and safe cab services for your Mumbai to Bhimashankar journey. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure that your trip is smooth and enjoyable.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rahul Tiwari',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made our trip to Bhimashankar from Mumbai a memorable experience. The vehicle was comfortable, the driver was courteous and professional, and we reached our destination on time. Highly recommend their services for long trips like this!”',
        },
        {
          name: 'Mrs. Priya Reddy',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my visit to Bhimashankar from Mumbai, and it was a pleasant experience. The driver was familiar with the route, and the ride was smooth and relaxing. I will definitely choose them for my future trips!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Bhimashankar Cab",
        "description": "Book affordable and reliable Mumbai to Bhimashankar cab services for one-way trips, round trips, and private cabs. S9 Travels offers comfortable transport for Bhimashankar temple tours, pilgrimage trips, sightseeing, and group travel from Mumbai to Bhimashankar.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
      
      


    return (
        <div>
          <Helmet>
        <title>Mumbai to Bhimashankar Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Bhimashankar taxi services, including one-way, round-trip, and private cabs. Affordable and reliable transport for Bhimashankar temple tours, pilgrimage trips, and sightseeing with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
     
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitobhimashankarcab;